import * as Yup from 'yup';
import { messages } from 'app/config/constants';

export const deliveryOrderValidationSchema = Yup.object().shape({
  publicAuthorities:
    Yup.array()
      .of(
        Yup.array().of(Yup.object()).min(1, messages.MANDATORY_FIELD)
          .test('unique-value', 'Vrijednost mora biti jedinstvena', (value, context) => {
            const { options } = context;
            const values = options.context?.publicAuthorities || [];
            const duplicates = values.filter(item => {
              return JSON.stringify(item) === JSON.stringify(value);
            });
            return duplicates.length <= 1;
          }),
      )
});
